import {
  createStyles,
  makeStyles,
  MenuItem,
  Typography,
} from "@material-ui/core"
import clsx from "clsx"
import dayjs from "dayjs"
import React, { FC, useState } from "react"
import { getReportedMoodDays } from "../../../utils/moodChart"
import { colors } from "../../../utils/theme"
import { MoodBarDataProps } from "../../../utils/types"
import Select from "../../atoms/Select"
import MoodBarChartMonthly from "../../molecules/MoodBarChartMonthly"
import MoodBarChartWeekly from "../../molecules/MoodBarChartWeekly"

enum TIME_PERIOD {
  WEEK = "week",
  MONTH = "month",
}

const MoodBarChart: FC<MoodBarDataProps> = ({
  data = [],
  timePeriod,
  setTimePeriod,
}) => {
  const classes = useStyles()

  const handleTimePeriodChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    setTimePeriod!!(e.target.value as TIME_PERIOD)
  }

  return (
    <div className={classes.chartContainer}>
      <div className={classes.headerContainer}>
        <Typography
          variant="h5"
          component="h5"
          className={clsx(classes.header)}
        >
          Mood Balance
        </Typography>
        <Select value={timePeriod} onChange={handleTimePeriodChange}>
          <MenuItem value={TIME_PERIOD.WEEK}>Past Week</MenuItem>
          <MenuItem value={TIME_PERIOD.MONTH}>Past Month</MenuItem>
        </Select>
      </div>
      {timePeriod === TIME_PERIOD.WEEK ? (
        <MoodBarChartWeekly data={getReportedMoodDays(dayjs(), 7, data)} />
      ) : (
        <MoodBarChartMonthly data={getReportedMoodDays(dayjs(), 30, data)} />
      )}
    </div>
  )
}

export default MoodBarChart

const useStyles = makeStyles((theme) =>
  createStyles({
    chartContainer: {
      position: "relative",
      backgroundColor: "white",
      marginTop: theme.spacing(2),
      paddingTop: 37,
      border: `1px solid ${colors.neutral.clay}`,
      borderRadius: 4,
    },
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: theme.spacing(4.5),
      marginRight: theme.spacing(4.5),
      marginBottom: theme.spacing(2),
    },
    header: {
      fontWeight: 400,
      width: theme.spacing(25),
      color: colors.neutral.denim,
    },
  })
)
